export const GET_SHOP_THE_LOOK_PRODUCTS_SUCCESS = 'GET_SHOP_THE_LOOK_PRODUCTS_SUCCESS';
export const GET_SHOP_THE_LOOK_PRODUCTS_ERROR = 'GET_SHOP_THE_LOOK_PRODUCTS_ERROR';
export const FOUND_RELATED_PRODUCTS = 'FOUND_RELATED_PRODUCTS';

export function getShopTheLookProductsSuccess(relatedProductDetailData) {
    return {
        type: GET_SHOP_THE_LOOK_PRODUCTS_SUCCESS,
        meta: {
        },
        payload: relatedProductDetailData
    };
}

export function getShopTheLookProductsError(err) {
    return {
        type: GET_SHOP_THE_LOOK_PRODUCTS_ERROR,
        meta: {
        },
        payload: err,
        error: true
    };
}

export function foundRelatedProducts(relatedProductInfo) {
    return {
        type: FOUND_RELATED_PRODUCTS,
        meta: {
        },
        payload: relatedProductInfo
    };
}
